<template>
  <main>
    <div class="container-fluid p-4">
      <!-- Quick Access Cards -->
      <quick-access-cards />
      
      <!-- Slider -->
      <slider-container />

      <!-- Featured Cards -->
      <featured-cards />
    </div>
  </main>
</template>

<script>
import QuickAccessCards from "../components/quick_access/QuickAccessCards.vue";
import FeaturedCards from "../components/featured_card/FeaturedCards.vue";
import SliderContainer from "../components/slider/SliderContainer.vue";
export default {
  name: "Home",
  components: {
    QuickAccessCards,
    FeaturedCards,    
    SliderContainer
  },
  mounted() {
    //this.encode();
  },
  data() {
    return {
      email: null,
      employee_code: null,
    };
  },  
  methods: {
    /* encode() {
      console.log(this.user);
      this.email = btoa(this.user.email);
      this.employee_code = btoa(this.user.employee_code);
    }, */
  },
};
</script>
